<template>
  <div>
    <!-- 登录中 -->
  </div>
</template>

<script>
import { setToCodeUrl } from '@/utils/config'
import { getUrlCode } from '@/utils/util'
import { getStore, removeStore, setStore } from '@/utils/store'
export default {
  components: {},
  data() {
    return {}
  },
  beforeRouteEnter(to, from, next) {
    if (from.query.secondaryRollback) {
      console.info('二次回退问题:::', from)
      // 二次回退问题
      // WeixinJSBridge.call('closeWindow');
      next(false)
      wx.closeWindow()
    }
    next()

    // if (from.fullPath === getStore({ name: 'redirect' })) {
    //   // 二次回退问题
    //   // console.log('触发')
    //   // window.close()
    //   next({ name: 'homeIndex' });
    // }
    // if(from.name !== 'homeIndex'){
    //   next();
    // }
  },
  beforeRouteLeave(to, from, next) {
    next()
  },
  methods: {
    login() {
      const code = getUrlCode().code
      if (code) {
        console.log(this.$route.query.redirect)
        this.$store.dispatch('Login', { wxLoginCode: code }).then((res) => {
          this.$router.push({
            path: this.$route.query.redirect,
            query: { secondaryRollback: true }
          })
        })
      } else {
        let url = setToCodeUrl(`/login?redirect=${this.$route.fullPath}`)
        window.location.href = url
      }
    }
  },
  created() {},
  props: {},
  watch: {},
  computed: {},
  mounted() {
    this.login()
  }
}
</script>

<style scoped lang="scss"></style>
